import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { MarquesVehiclesService } from '../../services/marques-vehicles-service.service';
import { FormService } from 'path-shared/services/form/form.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { MarquesVehicles } from '../../models/marques-vehicles.model';
import { ModelsMarques } from '../../models/models-marques.model';
import { ModelsVehiclesComponent } from '../models-vehicles/models-vehicles.component';
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'app-marques-vehicles-editor',
  templateUrl: './marques-vehicles-editor.component.html',
  styleUrls: ['./marques-vehicles-editor.component.scss']
})
export class MarquesVehiclesEditorComponent implements OnInit {

  secure_id: string;
  marcaVehicle: MarquesVehicles;
  public modelos: BehaviorSubject< ModelsMarques[]>;
  listaModelos;
  displayedColumns: string[] = ['id', 'name', 'referenciaIntegracion', 'action'];
  dialogData: ComponentDialog;
  closeButtonText: string;

  @ViewChild('mainForm') private mainForm: ElementRef;

  constructor(private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private marcaVehiclesService: MarquesVehiclesService,
    private i18n: I18n,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    public thisDialogRef: MatDialogRef<MarquesVehiclesEditorComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.marcaVehicle = Builder.newMarcaVehicle();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Tancar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
      this.modelos = new BehaviorSubject(new Array <ModelsMarques>());
      this.listaModelos = this.modelos.asObservable();
    }

  ngOnInit() {
    if (this.secure_id !== null) {
      this.marcaVehiclesService.getMarca(this.secure_id).subscribe(data => {
        this.marcaVehicle = data;
        const modelosActuales: ModelsMarques[] = Object.assign([], this.marcaVehicle.modelos);
        // const avisos: AvisosConf[] = Object.assign(result);
        // const data = this.buildFileTree(avisos, 0);
        // this.dataChange.next(data);

        this.modelos.next(modelosActuales);
      });
    }
  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.marcaVehiclesService.setMarca(this.marcaVehicle).subscribe(result => {
        this.toastr.info(this.i18n('Marca vehicle guardada correctament'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hi ha errors en el formulari!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Segur que vol esborrar la marca?'))
    .then((confirmed) => {
        if (confirmed) {
          this.marcaVehiclesService.removeMarca(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('Marca esborrada correctament'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }

  openDialog(action, obj) {
    obj.action = action;
    const dialogRef = this.dialog.open(ModelsVehiclesComponent, {
      width: '40%',
      height: '30%',
      closeOnNavigation: false,
      autoFocus: true,
      data: obj
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'Add') {
        this.addModel(result.data);
      } else if (result.event === 'Update') {
        this.updateModel(result.data);
      } else if (result.event === 'Delete') {
        this.deleteModel(result.data);
      }
    });
  }

  addModel(row_obj: ModelsMarques) {
    row_obj.secureIdMarca = this.marcaVehicle.secureId;
    this.marcaVehiclesService.setModelo(row_obj).subscribe(res => {
      this.marcaVehiclesService.GetModelosMarca(this.marcaVehicle.secureId).subscribe(newModels => {
        const modelosActuales: ModelsMarques[] = Object.assign([], newModels);
        this.modelos.next(modelosActuales);
      });
    });

  }
  updateModel(row_obj: ModelsMarques) {
    row_obj.secureIdMarca = this.marcaVehicle.secureId;
    this.marcaVehiclesService.setModelo(row_obj).subscribe(res => {
      this.marcaVehiclesService.GetModelosMarca(this.marcaVehicle.secureId).subscribe(newModels => {
        const modelosActuales: ModelsMarques[] = Object.assign([], newModels);
        this.modelos.next(modelosActuales);
      });
    });
  }
  deleteModel(row_obj) {

    this.marcaVehiclesService.deleteModelo(row_obj).subscribe(res => {
      this.marcaVehiclesService.GetModelosMarca(this.marcaVehicle.secureId).subscribe(newModels => {
        const modelosActuales: ModelsMarques[] = Object.assign([], newModels);
        this.modelos.next(modelosActuales);
      });
    });
  }

}
